import { registerFirestoreDocumentConverter } from "@/firestore/myFreeReads"
import { dexieFirestoreDocument, FirestoreDocument } from "@/types/firestoreDocument"
import { z } from "zod"
import { setHours, setMinutes } from "date-fns"

export const globalSettingsSchema = z.object({
   current_schoolyear_id: z.string().min(1, "L'ID de l'année scolaire est requis"),
   groups: z.array(z.string()).default([]),
   start_of_day: z.string().default("08:30"),
   morning_break: z.string().default("10:30"),
   lunch_break: z.string().default("12:30"),
   afternoon_break: z.string().default("15:30"),
   end_of_day: z.string().default("17:00"),
})

export type GlobalSettings = z.infer<typeof globalSettingsSchema> & FirestoreDocument

export const collectionName = "global_settings"
export const mainDocumentId = "main"

export const dexieGlobalSettings = dexieFirestoreDocument

export const init = () =>
   registerFirestoreDocumentConverter<GlobalSettings>(collectionName, (data) => {
      return data
   })

export const getDayQuarters = (globalSettings: GlobalSettings, day: Date) => {
   // Convert time strings to hours and minutes
   const [startHours, startMinutes] = globalSettings.start_of_day.split(":").map(Number)
   const [morningBreakHours, morningBreakMinutes] = globalSettings.morning_break
      .split(":")
      .map(Number)
   const [lunchBreakHours, lunchBreakMinutes] = globalSettings.lunch_break.split(":").map(Number)
   const [afternoonBreakHours, afternoonBreakMinutes] = globalSettings.afternoon_break
      .split(":")
      .map(Number)
   const [endHours, endMinutes] = globalSettings.end_of_day.split(":").map(Number)

   return [
      // Morning first half
      {
         start: setMinutes(setHours(day, startHours), startMinutes),
         end: setMinutes(setHours(day, morningBreakHours), morningBreakMinutes),
      },
      // Morning second half
      {
         start: setMinutes(setHours(day, morningBreakHours), morningBreakMinutes),
         end: setMinutes(setHours(day, lunchBreakHours), lunchBreakMinutes),
      },
      // Afternoon first half
      {
         start: setMinutes(setHours(day, lunchBreakHours), lunchBreakMinutes),
         end: setMinutes(setHours(day, afternoonBreakHours), afternoonBreakMinutes),
      },
      // Afternoon second half
      {
         start: setMinutes(setHours(day, afternoonBreakHours), afternoonBreakMinutes),
         end: setMinutes(setHours(day, endHours), endMinutes),
      },
   ]
}
